import { render, staticRenderFns } from "./TicketItemDetails.vue?vue&type=template&id=45249499&scoped=true&"
import script from "./TicketItemDetails.vue?vue&type=script&lang=ts&"
export * from "./TicketItemDetails.vue?vue&type=script&lang=ts&"
import style0 from "./TicketItemDetails.vue?vue&type=style&index=0&id=45249499&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45249499",
  null
  
)

export default component.exports